module.exports = __webpack_public_path__ + "img/41.86ac0a43.86ac0a43.svg";